import React from 'react';
import PropTypes from 'prop-types';

import StyledCard from "components/card/StyledCard";
import ProgressBar from "components/ProgressBar";

ScorePerContext.propTypes = {
    scores: PropTypes.shape({
        seo: PropTypes.number,
        marketplace: PropTypes.number,
        driveToStore: PropTypes.number
    })
};

function ScorePerContext({scores}) {
    return (
        <StyledCard style={{
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            width: '100%',
            gap: '12px',
        }}>
            <span style={{
                textTransform: 'uppercase',
                color: '#767c89',
                fontWeight: 600,
                fontSize: '12px'
            }}>
                Scores par contexte
            </span>
            <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                <ProgressBar percentage={scores.seo} label={'SEO'} variant={'secondary'} />
                <ProgressBar percentage={scores.marketplace} label={'Marketplace'} variant={'secondary'} />
                <ProgressBar percentage={scores.driveToStore} label={'Drive-to-store'} variant={'secondary'} />
            </div>
        </StyledCard>
    );
}

export default ScorePerContext;
